import styled from 'styled-components'
import Button from '~components/dumbs/Button'

export const PrimaryButton = styled(Button)<{ forWhatsApp?: boolean }>`
  ${({ theme, forWhatsApp }) =>
    forWhatsApp &&
    `
      background-color: ${theme.support.green.base};
      :hover {
        background-color: #069e59;
      }
    `}

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-bottom: ${({ theme }) => theme.spacing.km1};
  }
`
